import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { jobdocumentsRoutes } from './lib.routes';
import { ExtensionService, provideExtensionConfig } from '@alfresco/adf-extensions';
import { OauthService } from './services/oauth.service';
import { CarlisleContentManagementService } from './services/carlisle-content-management.service';
import { ViewDocumentService } from './services/view-document.service';
import { DocuServeConfigurationService } from './services/docuserve-configuration.service';
import { MoveNodeActionComponent } from './components/actions/move-node-action.component';
import { CopyNodeActionComponent } from './components/actions/copy-node-action.component';
import { AevNodeTabComponent } from './components/aev-node-tab.component';
import { CreatePdfComponent } from './components/create-pdf-dialog/create-pdf.component';
import { EnterpriseViewerTab } from './components/EnterpriseViewer/enterprise-viewer-tab.component ';
import { EnterpriseViewer } from './components/EnterpriseViewer/enterprise-viewer.component';
import { AddExistingTagActionComponent } from './components/tags/add-existing-tag-action/add-existing-tag-action.component';
import { TagsTabComponent } from './components/tags/tags-tab/tags-tab.component';
import { UploaderPlusComponent } from './components/uploader-plus/uploader-plus.component';
import { ViewInTabActionComponent } from './components/view-in-tab-action.component';
import { ViewInTabComponent } from './components/view-in-tab/view-in-tab.component';
import { SelectCategoryDialogComponent } from './dialogs/select-category-dialog/select-category-dialog.component';
import { SafePipe } from './pipes/safe';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { TagNodeListComponent } from '@alfresco/adf-content-services';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import { MatStepperModule } from '@angular/material/stepper';
import { PageLayoutModule } from '@alfresco/aca-shared';
import { ToolbarModule, TranslationService } from '@alfresco/adf-core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import * as jobdocumentsRules from './rules/actions.rules';
import { EffectsModule } from '@ngrx/effects';
import { JobDocumentsEffects } from './effects/jobdocuments.effects';
import { UploadJobdocumentsEffects } from './effects/upload.jobdocuments.effects';
import { BluebeamService } from './services/bluebeam.service';
import {SiteRoleTemplate} from './role/site-role-column.template';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(jobdocumentsRoutes),
    TranslateModule,
    MatIconModule,
    MatCardModule,
    MatChipsModule,
    TagNodeListComponent,
    MatCardModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    MatDialogModule,
    MatStepperModule,
    MatTooltipModule,
    PageLayoutModule,
    ToolbarModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    EffectsModule.forFeature([JobDocumentsEffects, UploadJobdocumentsEffects]),

   ],
  declarations: [
    UploaderPlusComponent,
    TagsTabComponent,
    AddExistingTagActionComponent,
    SafePipe,
    EnterpriseViewer,
    EnterpriseViewerTab,
    ViewInTabActionComponent,
    ViewInTabComponent,
    AevNodeTabComponent,
    CreatePdfComponent,
    SelectCategoryDialogComponent,
    MoveNodeActionComponent,
    CopyNodeActionComponent,
    SiteRoleTemplate

  ],
  providers: [
    provideExtensionConfig(['carlislehomes.jobdocuments.json']),
    DocuServeConfigurationService,
    ViewDocumentService,
    CarlisleContentManagementService,
    OauthService,
    BluebeamService
  ],
  entryComponents: [SelectCategoryDialogComponent, SiteRoleTemplate],
  exports: [
    UploaderPlusComponent,
    TagsTabComponent,
    EnterpriseViewer
  ]
})
export class JobdocumentsModule {

  constructor(extensions: ExtensionService, translation: TranslationService) {

    translation.addTranslationFolder('jobdocuments', 'assets/jobdocuments');

    extensions.setEvaluators({
      'jobdocuments.role.hasBluebeamEditRole': jobdocumentsRules.hasBluebeamEditRole,
      'jobdocuments.selection.canOpenWithBluebeam': jobdocumentsRules.canOpenWithBluebeam,
      'jobdocuments.role.hasAdminRole': jobdocumentsRules.hasAdminRole,
      'jobdocuments.navigation.isCategoryFolder': jobdocumentsRules.isCategoryFolder,
      'jobdocuments.selection.isJobDocument': jobdocumentsRules.isJobDocument,
      'jobdocuments.navigation.isSupportingDocumentsFolder': jobdocumentsRules.isSupportingDocumentsFolder,
      'jobdocuments.role.hasDisplayTeamRole': jobdocumentsRules.hasDisplayTeamRole
    });

    extensions.setComponents({
      "ch.components.tabs.tags": TagsTabComponent,
      'app.components.enterprise-viewer': EnterpriseViewer,
      'app.toolbar.component.aevViewNode': AevNodeTabComponent,
      'app.toolbar.component.viewInTabNode': ViewInTabActionComponent,
      'app.toolbar.component.createPdf': CreatePdfComponent,
      'app.toolbar.component.movejobdocument': MoveNodeActionComponent,
      'app.toolbar.component.copyjobdocument': CopyNodeActionComponent,
      'app.features.documentList.libraries.role.template': SiteRoleTemplate
    });
  }


}
